import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import { Icon } from '../Icons';

import './styles/buttonSmallStyles.css';
import './styles/buttonStyles.css';
import './styles/linkButtonStyles.css';
import './styles/closeButtonStyles.css';

const sizes = {
  default: '',
  small: 'button-small',
};

// TODO: Change "children" to an actual prop. A button should not allow any child within it.
const ButtonBase = ({
  children,
  className,
  disabled,
  isLoading,
  isSubmit,
  onClick,
  size,
  ...rest
}) => (
  <button
    className={`${className} ${sizes[size] || ''}`}
    disabled={disabled || isLoading}
    onClick={onClick}
    type={isSubmit ? 'submit' : 'button'}
    {...rest}
  >
    {isLoading && (
      <Fragment>
        <Icon icon={faSpinnerThird} spin />{' '}
      </Fragment>
    )}
    {children}
  </button>
);

ButtonBase.defaultProps = {
  className: '',
  disabled: false,
  isLoading: false,
  isSubmit: false,
  size: 'default',
};

ButtonBase.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSubmit: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['default', 'small']),
};

export default ButtonBase;
